import { OrderStatus } from "../../../generated/graphql";
import type { MessageDescriptor } from "react-intl";

type TranslateStatusMessage = (message: MessageDescriptor) => string;

const orderStatuses = Object.values(OrderStatus);

export const orderStatusSortOrder: Record<OrderStatus, number> = {
  [OrderStatus.Draft]: 0,
  [OrderStatus.AwaitingDelivery]: 1,
  [OrderStatus.PartiallyDelivered]: 2,
  [OrderStatus.PartiallyDeliveredCompletionRequired]: 3,
  [OrderStatus.Delivered]: 4,
  [OrderStatus.InRevision]: 5,
  [OrderStatus.Approved]: 6,
  [OrderStatus.PendingApproval]: 7,
  [OrderStatus.Cancelled]: 8,
};

const orderStatusLabelByStatus: Record<OrderStatus, string> = {
  DRAFT: "orderstatus-draft",
  AWAITING_DELIVERY: "orderstatus-awaitingDelivery",
  DELIVERED: "orderstatus-delivered",
  PARTIALLY_DELIVERED: "orderstatus-partiallyDelivered",
  PARTIALLY_DELIVERED_COMPLETION_REQUIRED:
    "orderstatus-partiallyDeliveredCompletionRequired",
  IN_REVISION: "orderstatus-inRevision",
  CANCELLED: "orderstatus-cancelled",
  // deprecated statuses, used only in old orders
  PENDING_APPROVAL: "orderstatus-pendingApproval",
  APPROVED: "orderstatus-approved",
};

export const deprecatedStatuses = [
  OrderStatus.PendingApproval,
  OrderStatus.Approved,
];

const getOrderStatusTranslationId = (status?: string | null) =>
  status ? orderStatusLabelByStatus[status as OrderStatus] : undefined;

const getOrderStatusLabel = (status?: string | null) =>
  getOrderStatusTranslationId(status) ?? status ?? "";

const getOrderStatusDisplayName = (
  status?: string | null,
  fallbackName?: string,
  translate?: TranslateStatusMessage,
) => {
  const translationId = getOrderStatusTranslationId(status);

  if (translationId && translate) {
    return translate(
      fallbackName
        ? { id: translationId, defaultMessage: fallbackName }
        : { id: translationId },
    );
  }

  return fallbackName ?? status ?? "";
};

export {
  orderStatuses,
  getOrderStatusLabel,
  getOrderStatusDisplayName,
  getOrderStatusTranslationId,
  orderStatusLabelByStatus,
};
